import { Action, createReducer, on } from '@ngrx/store';

import * as actions from './actions';
import { AppState } from '../shared/models';

const appReducer = createReducer<AppState>(
  {},
  on(actions.init, (state, { entityExternalId, system }) => ({
    ...state,
    entityExternalId,
    system,
  })),
  on(actions.initialized, (state) => ({
    ...state,
    initialized: true,
  })),
  on(actions.setApplications, (state, { applications }) => ({
    ...state,
    applications: [...applications].sort((a, b) =>
      a.displayName > b.displayName ? 1 : b.displayName > a.displayName ? -1 : 0,
    ),
  })),
  on(actions.setApplicationGroups, (state, { applicationGroups }) => ({
    ...state,
    applicationGroups: [...applicationGroups].sort((a, b) =>
      a.displayName > b.displayName ? 1 : b.displayName > a.displayName ? -1 : 0,
    ),
  })),
  on(actions.setDatastreams, (state, { datastreams }) => ({
    ...state,
    datastreams: [...datastreams].sort((a, b) =>
      a.displayName > b.displayName ? 1 : b.displayName > a.displayName ? -1 : 0,
    ),
  })),
  on(actions.setApplicationDatastreams, (state, { applicationDatastreams }) => ({
    ...state,
    applicationDatastreams,
  })),
  on(actions.setGroupDatastreams, (state, { groupId }) => ({
    ...state,
    applicationGroups: state.applicationGroups.map((applicationGroup) =>
      applicationGroup.id === groupId ? { ...applicationGroup, show: true } : applicationGroup,
    ),
  })),
  on(actions.setApplicationDatastream, (state, { dataStreamKeys, applicationKey }) => ({
    ...state,
    applicationDatastreams: [
      ...state.applicationDatastreams,
      ...dataStreamKeys.map((dataStreamKey) => ({
        dataStreamKey,
        applicationKey,
      })),
    ],
  })),
  on(actions.deleteApplicationDatastream, (state, { dataStreamKeys, applicationKey }) => ({
    ...state,
    applicationDatastreams: state.applicationDatastreams.filter(
      (applicationDatastream) =>
        applicationDatastream.applicationKey !== applicationKey ||
        dataStreamKeys.indexOf(applicationDatastream.dataStreamKey) === -1,
    ),
  })),
  on(actions.deleteGroupDatastreams, (state, action) => {
    const applications = state.applications
      .filter((application) => application.applicationGroupId === action.group.id)
      .map((application) => application.key);
    return {
      ...state,
      applicationGroups: state.applicationGroups.map((group) =>
        group.id === action.group.id ? { ...group, show: false } : group,
      ),
      applicationDatastreams: [
        ...state.applicationDatastreams.filter(
          (applicationDatastream) =>
            applications.indexOf(applicationDatastream.applicationKey) === -1,
        ),
      ],
    };
  }),
);

export const reducer = (state: AppState | undefined, action: Action) => appReducer(state, action);
